import Button from 'components/Button';
import InlinePage from 'components/Page/Inline';
import InfoLink from 'components/links/Info';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';

export default function PediatricTagsPage() {
  return (
    <ReadableWidthTemplate title="Pediatric Tags">
      <h3>
        Variant Annotations{' '}
        <InfoLink
          href="/variantAnnotations"
          tooltip="Learn about variant annotations"
          iconClassName="icon--superscript"
          iconSize="xs"
        />
      </h3>
      <InlinePage
        id="pediatricVariantAnnotationsHeader"
        extraControls={<Button href="/pediatric/variantAnnotations" className="btn-secondary">Pediatric VA Page</Button>}
        className="mb-4"
      />

      <h3>
        Summary Annotations{' '}
        <InfoLink
          href="/summaryAnnotations"
          tooltip="Learn about summary annotations"
          iconClassName="icon--superscript"
          iconSize="xs"
        />
      </h3>
      <InlinePage
        id="pediatricClinicalAnnotationsHeader"
        extraControls={<Button href="/pediatric/summaryAnnotations" className="btn-secondary">Pediatric CA Page</Button>}
        className="mb-4"
      />

      <h3>
        Label Annotations{' '}
        <InfoLink
          href="/labelAnnotations"
          tooltip="Learn about label annotations"
          iconClassName="icon--superscript"
          iconSize="xs"
        />
      </h3>
      <InlinePage
        id="pediatricLabelAnnotationsHeader"
        extraControls={<Button href="/pediatric/labelAnnotations" className="btn-secondary">Pediatric Label Ann Page</Button>}
        className="mb-4"
      />

      <h3>
        Guideline Annotations{' '}
        <InfoLink
          href="/guidelineAnnotations"
          tooltip="Learn about guideline annotations"
          iconClassName="icon--superscript"
          iconSize="xs"
        />
      </h3>
      <InlinePage
        id="pediatricGuidelineAnnotationsHeader"
        extraControls={<Button href="/pediatric/guidelineAnnotations" className="btn-secondary">Pediatric Guideline Ann Page</Button>}
        className="mb-4"
      />


      <h3>Literature</h3>
      <InlinePage
        id="pediatricLiteratureHeader"
        extraControls={<Button href="/pediatric/literature" className="btn-secondary">Pediatric Literature Page</Button>}
        className="mb-4"
      />


      <h3>Drugs</h3>
      <InlinePage
        id="pediatricChemicalsHeader"
        extraControls={<Button href="/pediatric/chemicals" className="btn-secondary">Pediatric Drugs Page</Button>}
      />

    </ReadableWidthTemplate>
  );
}
